// extracted by mini-css-extract-plugin
export default {"portfolioListBox":"PortfolioList_portfolioListBox__kDQC4","features":"PortfolioList_features__U8BOS","portfolioListBox__header":"PortfolioList_portfolioListBox__header__dMsKz"};